<div class="flex flex-row items-center font-base py-12">
  <img
    src="../../../../../assets/images/spinner.svg"
    class="pr-4"
  />
  Connexion&hellip;
</div>
